import ProjectBrowseSidebarModule from './project-browse-sidebar.module'

export default ProjectBrowseSidebarModule
